import React from "react";
import { projects } from "../../constants/constants";
import ProjectCard from "./ProjectCard";
import "./project.css";



const Project = () => {
  return (
    <div style={{ paddingTop: "40px", paddingBottom: "40px" }}>
      <h1 id="project" className="heading">
        My <span className="heading-highlight">Project</span> Section
      </h1>
      <div className="project-container">
        {projects.map(({ title, imgPath, description, stack, link, demo }) => (
          <ProjectCard
            key={title}
            title={title}
            imgPath={imgPath}
            description={description}
            stack={stack}
            link={link}
            demo={demo}
          />
        ))}
      </div>
    </div>
  );
};

export default Project;
